import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';
import { InfoMessage } from '../../components/InfoMessage';

import formStyles from '../../scenes/FormStart/index.module.css';
import defaultStyles from '../../styles/formSetStyles.module.css';
import questionStyles from '../../components/Question/index.module.css';
import NavBar, { View } from '../../components/NavBar';
import Enum from '../../components/Question/Enum';

interface Props {
  zipCodes: string[];
  login: (zipCode: string) => void;
  zipError?: string;
  maxAttempts?: boolean;
}

const ZipSelection: React.FC<Props> = ({
  zipCodes,
  login,
  zipError,
  maxAttempts,
}) => {
  const [zip, selectZip] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('login');
  return (
    <div className={formStyles.Form}>
      <NavBar view={View.Login} />
      <div className={questionStyles.Label}>
        {t('securityResideInWhichZIPCode')}
      </div>

      <div className={questionStyles.Answer}>
        {zipError && <InfoMessage isError>{t(zipError)}</InfoMessage>}
        <Enum value={zip} options={zipCodes} onChange={selectZip} />
      </div>

      <div className={defaultStyles.ButtonSubmitWrapper}>
        <Button
          disabled={maxAttempts || !zip || isSubmitting}
          type="button"
          children={t('continue')}
          onClick={() => {
            setIsSubmitting(true);
            login(zip);
            setIsSubmitting(false);
          }}
        />
      </div>
    </div>
  );
};

export default ZipSelection;
